"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedDateDotsForDate = void 0;
/**
 * Formats a given date with / by dot(.).
 * - If date is undefined it will return N/A.
 *
 * @param {Date} date - The value to be formatted.
 * @returns {string} - The formatted date, or original/empty string based on conditions.
 */
const getFormattedDateDotsForDate = (date) => {
    if (date === undefined) {
        return "N/A";
    }
    return date.toLocaleString('en-US').split(',')[0].replace(/\//g, ".");
};
exports.getFormattedDateDotsForDate = getFormattedDateDotsForDate;
